{
  "title": "Resolve Unknown Aircraft",
  "description": "Aircraft that couldn't be matched during data import. Select an aircraft type to create a tenant. An administrator will review and approve FAA mapping later.",
  "alerts": {
    "noActiveFBO": "No active FBO selected",
    "noPendingAircraft": "No pending aircraft - all synced aircraft have been matched!"
  },
  "toolbar": {
    "refresh": "Refresh",
    "pendingCount": "Pending Count"
  },
  "table": {
    "headers": {
      "tailNumber": "Tail Number",
      "typeHint": "Type Hint",
      "operator": "Operator",
      "mapToAircraft": "Map to Aircraft",
      "created": "Created"
    },
    "empty": "No pending aircraft",
    "processing": "Creating tenant...",
    "selectAircraft": "Select aircraft"
  },
  "messages": {
    "userNotAuthenticated": "User not authenticated",
    "mappingFailed": "Failed to map aircraft"
  },
  "fallbacks": {
    "unknownOperator": "Unknown",
    "unknownType": "Unknown"
  }
}
